/**
 * Adventure-specific family helper methods
 * Extracted from FamiliesHelper for better encapsulation
 */

const AdventureFamiliesHelper = {
    Shape2x4Vertical: [
        { x: 0, y: 0, passable: true },
        { x: 0, y: 1, passable: true },
        { x: 0, y: 2, passable: true },
        { x: 0, y: 3, passable: true },
        { x: 1, y: 0, passable: true },
        { x: 1, y: 1, passable: true },
        { x: 1, y: 2, passable: true },
        { x: 1, y: 3, passable: true }
    ],

    ShapeSquarePassableStrip: [
        { x: 0, y: 0, passable: true },
        { x: 1, y: 0 },
        { x: 0, y: 1, passable: true },
        { x: 1, y: 1 }
    ],

    Shape2x3: [
        { x: 0, y: 0 },
        { x: 0, y: 1 },
        { x: 0, y: 2 },
        { x: 1, y: 0 },
        { x: 1, y: 1 },
        { x: 1, y: 2 }
    ],

    Shape3x2: [
        { x: 0, y: 0 },
        { x: 1, y: 0 },
        { x: 2, y: 0 },
        { x: 0, y: 1 },
        { x: 1, y: 1 },
        { x: 2, y: 1 }
    ],

    AdventureSourceFamily: function (stages, options) {
        const units = [];

        for (const stage of cleverapps.toArray(stages)) {
            const unit = {
                pointOfInterest: options.pointOfInterest,
                unmergeable: true,
                stopsfog: true,
                multicell: stage.multicell || options.multicell,
                autoCollect: true,
                simpleInfo: true,
                harvestOnSecondClick: true,
                isTree: true,
                multiple: true,
                mineable: {
                    tasks: cleverapps.toArray(stage.mineable || [stage]).map((level) => ({
                        time: "0 second",
                        energy: level.energy,
                        exp: Math.ceil(level.energy / 10),
                        prizes: Object.keys(level.prizes).map((code) => {
                            if (code === "energy") {
                                return { resource: code, amount: level.prizes[code] };
                            }
                            return { ingredient: code, amount: level.prizes[code] };
                        })
                    }))
                }
            };

            units.push(unit);
        }

        return {
            type: options.type,
            units,
            expeditions: options.expeditions
        };
    },

    AdventureLeveledSourceFamily: function (stages, options) {
        const levels = cleverapps.toArray(stages).map((stage) => ({
            energy: stage.energy,
            prizes: stage.prizes
        }));

        cleverapps.toArray(stages).forEach((stage, index) => {
            stage.mineable = levels.slice(0, index + 1).reverse();
        });

        return AdventureFamiliesHelper.AdventureSourceFamily(stages, options);
    },

    AdventurePrizesFamily: function (stages, options) {
        const units = cleverapps.toArray(stages).map((stage) => ({
            multicell: options.multicell,
            unmergeable: true,
            stopsfog: true,
            lockable: {
                duration: stage.unlock
            },
            autoCollect: true,
            simpleInfo: true,
            mineable: {
                tasks: [{
                    time: "0 second",
                    energy: 0,
                    exp: 0,
                    prizes: cleverapps.toArray(stage.prize)
                }]
            }
        }));

        return {
            type: options.type,
            units,
            quest: options.quest,
            expeditions: options.expeditions
        };
    },

    AdventureCustomerFamily: function (options) {
        const units = [];

        for (let i = 0, total = options.total ? options.total - 1 : 1; i < total; ++i) {
            units.push({
                stopsfog: options.stopsfog !== undefined ? options.stopsfog : true,
                movable: false,
                customer: true,
                climbable: true,
                simpleClimb: true,
                important: true,
                pointOfInterest: true,
                multicell: options.multicell,
                cookingAnimation: options.cookingAnimation,
                landmarkDonor: true
            });
        }

        units.push({
            composite: options.composite,
            important: true,
            movable: false,
            clickable: !!options.finishHint,
            multicell: options.multicell,
            landmarkDonor: {
                finishHint: options.finishHint ? "LandmarkDonor.FinishedHint" : undefined
            }
        });

        return {
            type: options.type,
            units,
            expeditions: options.expeditions
        };
    },

    SpecialUnitFamily: function (unit, options) {
        options = options || {};

        if (!Array.isArray(unit) && options.produceOnlyWhenNeeded !== undefined) {
            unit.produceOnlyWhenNeeded = options.produceOnlyWhenNeeded;
        }

        return {
            type: options.type,
            units: Array.isArray(unit) ? unit : cleverapps.arrayFill(options.total || 1, unit),
            expeditions: options.expeditions,
            images: options.images,
            oneViewForStages: options.oneViewForStages,
            locators: options.locators,
            extraBundles: options.extraBundles,
            localization: options.localization
        };
    },

    AdventureProductFamily: function (options) {
        const units = [
            {
                unmergeable: true,
                produceOnlyWhenNeeded: options.produceOnlyWhenNeeded
            },
            {
                unmergeable: true,
                produceOnlyWhenNeeded: options.produceOnlyWhenNeeded
            }
        ];

        return {
            type: options.type,
            units,
            expeditions: options.expeditions,
            locators: options.locators
        };
    }
};

if (typeof module !== "undefined") {
    module.exports = AdventureFamiliesHelper;
}
